import * as React from 'react';
import { Table, Textarea } from 'soprasteria-ui-library';
import { IOrthodonticReferral, IOrthodonticReferralReasonsForRequestedCompletion } from '../../../../models/IOrthodonticReferral';
import { dateTimeToDateString } from '../../../../helpers/DateHelper';

interface IOrthodonticReferralCompletionInformation {
    reasonsForRequestedCompletion: IOrthodonticReferralReasonsForRequestedCompletion[];
}

export const OrthodonticReferralCompletionInformation: React.FunctionComponent<IOrthodonticReferralCompletionInformation> = ({ reasonsForRequestedCompletion }) => {

    return (
        <>
            <div className="row readonly-less-margin">
                <h5 className="col-12">Kompletteringsbegäran</h5>
            </div>
            <div className="row readonly-less-margin">
                <div className="col-12">
                    <Table>
                        <thead>
                            <tr>
                                <th style={{ width: "10%" }}>Skapad</th>
                                <th style={{ width: "20%" }}>Användare</th>
                                <th>Kommentar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reasonsForRequestedCompletion && reasonsForRequestedCompletion.length > 0 ?
                                    reasonsForRequestedCompletion.map((comment, key) =>
                                        <tr key={key}>
                                            <td className="text-nowrap">{dateTimeToDateString(comment.createdDate)}</td>
                                            <td className="text-nowrap">{comment.userName}</td>
                                            <td style={{ whiteSpace: "pre-line" }}>{comment.comment}</td>
                                        </tr>
                                    )
                                    : <tr><td colSpan={4}>Det finns inga kommentarer</td></tr>
                            }
                        </tbody>
                    </Table>
                </div>
            </div>
            <hr />
        </>
    )
}